<div class="card bg-primary-600 flex"style="background: rgb(30, 100, 231);">
  <div class="p-4 ml-4 flex-none self-center hidden sm:block" >
    <img
      src="assets/img/illustrations/checklist.svg"
      style="height: 168px; width: 152px" />
  </div>

  <div class="p-6 text-on-primary-600 flex-auto">
    <h1 class="headline m-0">{{Welcome}}, {{currentUser.userName}}!</h1>
    <h3 class="caption m-0 opacity-50">
      <span *ngFor="let role of currentUser.roles; let i = index">
        {{ role }}<span *ngIf="i < currentUser.roles.length - 1">, </span>
    </span>
    </h3>


 
  </div>
</div>
